import isAnimatedGif from '~/pegasus/animated_gif_detector.js';

window.colorsDistance = function(hex1, hex2) {
  var hex1LAB = $.colorspaces.make_color('hex', hex1).as('CIELAB');
  var hex2LAB = $.colorspaces.make_color('hex', hex2).as('CIELAB');
  var color1 = new colorLab( 'CIELAB', hex1LAB );
  var color2 = new colorLab( 'CIELAB', hex2LAB );
  var delta = color1.CIELAB.CIEDE2000( color2 );
  return delta;
};

window.hexValuesInString = function(str){
  var regex = new RegExp("#[A-Fa-f0-9]+", "gi");
  var matches = str.match(regex);

  if ( !matches ) { return []; }

  return matches.map(function(color){
    return color.toUpperCase();
  });
};

window.rgbValuesInString = function(str){
  var regex = new RegExp("rgb\\s*\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+\\s*\\)", 'ig');
  var rgbs = str.match(regex);

  var rgbValues = [];
  var currentRgb;

  if ( rgbs ) {
    rgbValues = rgbs.map(function(match){
      currentRgb = match.replace(/rgb|\(|\)|\s/ig, '').split(',');
      return Pegasus.Helpers.convertRgbToHex(
        currentRgb[0],
        currentRgb[1],
        currentRgb[2]
      ).toUpperCase();
    });
  }

  return rgbValues;
};

window.loadImage = function() {
  var file = document.getElementById("fileToLoad").files[0];

  var reader = new FileReader();
  reader.onload = function(event) {
    var data = event.target.result;

    var data16 = new Uint16Array(data);
    var text = [];
      for(i = 0; i<data16.length; i++){
          text.push(data16[i]);
      }

    document.getElementById("inputTextToSave").value = text;

    var imagePreview = document.getElementById("imagePreview");
    imagePreview.innerHTML = '';

    var dataURLReader = new FileReader();
    dataURLReader.onload = function(event) {
      // Parse image properties
      var dataURL = event.target.result;
      contentType = dataURL.split(",")[0].split(":")[1].split(";")[0];

      var image = new Image();
      image.src = dataURL;
      image.onload = function() {
        console.log("Image type: " + contentType);
        console.log("Image width: " + this.width);
        console.log("Image height: " + this.height);
        imagePreview.appendChild(this);
      };
    };
    dataURLReader.readAsDataURL(file);


  };
  //reader.readAsBinaryString(file);
  reader.readAsArrayBuffer(file);
};

window.b64ToBlob = function(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
};

window.saveImage = function(blob, name, contentType) {
  var downloadLink = document.createElement("a");
  downloadLink.download = name;
  downloadLink.innerHTML = "Download File";
  if (window.webkitURL !== null) {
    // Chrome allows the link to be clicked
    // without actually adding it to the DOM.
    downloadLink.href = window.webkitURL.createObjectURL(blob);
  }

  downloadLink.click();
};

window.findCanvasColors = function(){
  var str = Pegasus.canvasInstance.get('element').innerHTML;
  var hexValues = hexValuesInString(str);
  var rgbValues = rgbValuesInString(str);
  return hexValues.concat(rgbValues).uniq();
};

window.serializeSvgContent = function(element) {
  var result = '<' + element.nodeName;

  // add in the element's attributes
  for (var i = 0; i < element.attributes.length; i++) {
    var attribute = element.attributes[i];
    var name = attribute.name || attribute.nodeName;
    var value = (attribute.value || attribute.nodeValue).replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
    result += ' ' + name + '="' + value + '"';
  }

  if (element.childNodes.length > 0) {
    result += '>';

    // recursively add any child elements
    for (i = 0; i < element.childNodes.length; i++) {
      var child = element.childNodes[i];
      if (child.nodeType === 1) {
        result += serializeSvgContent(child);
      }
    }
    result += '</' + element.nodeName + '>';

  } else {
    result += '/>';
  }
  return result;
};

// works
window.convertSVGToBase64ForIE = function(svg, callback) {
  function execute(){
    var canvas, $img, img, xml, b64Start, svg64, imageSVG64, viewBox, $svgElement, parts, w, h, output, svgElement;

    canvas = $('<canvas>')[0];
    $img = $('<img>');
    img = $img[0];
    $svgElement = $(svg);
    var $div = $('<div>');
    $div.append($svgElement);
    svgElement = $svgElement[0];

    viewBox = svgElement.getAttribute('viewBox') || svgElement.getAttribute('viewbox');
    parts = viewBox.split(' ');
    w = parts[2];
    h = parts[3];

    var width = 620;
    var height = width * (h/w);

    canvas.height = height;
    canvas.width = width;

    // Firefox dies without this
    svgElement.setAttribute('width', width);
    svgElement.setAttribute('height', height);

    canvg( canvas, serializeSvgContent( svgElement ), {
      useCORS: true,
      ignoreDimensions: true,
      ignoreClear: true,
      ignoreMouse: true,
      ignoreAnimation: true,
      renderCallback: function(){
        output = canvas.toDataURL('image/png');

        callback({
          encoded: output
        });
      }
    });
  }

  import( /* webpackChunkName: "canvg" */ 'canvg').then(execute);
};

window.convertSVGToBase64 = function(svg, callback) {
  var canvas, $img, img, xml, b64Start, svg64, imageSVG64, viewBox, $svgElement, parts, w, h, output, svgElement;

  canvas = $('<canvas>')[0];
  $img = $('<img>');
  img = $img[0];
  $svgElement = $(svg);
  svgElement = $svgElement[0];

  viewBox = svgElement.getAttribute('viewBox') || svgElement.getAttribute('viewbox');
  parts = viewBox.split(' ');
  w = parts[2];
  h = parts[3];

  var width = 620;
  var height = width * (h/w);

  // Firefox dies without this
  svgElement.setAttribute('width', width);
  svgElement.setAttribute('height', height);

  //var parser = new DOMParser();
  //var doc = parser.parseFromString(svgElement.outerHTML, "text/xml");

  xml = serializeSvgContent( svgElement );
  b64Start = 'data:image/svg+xml;base64,';
  svg64 = btoa(unescape(encodeURIComponent(xml)))
  imageSVG64 = b64Start + svg64;
  canvas.height = height;
  canvas.width = width;
  window.convertToDataURLviaCanvas( imageSVG64, function(data){
    callback({
      encoded: data.encoded
    });
  }, Em.K, 'image/png', Pegasus.loadedTemplate().get('maxImageWidth') );
};

window.selectColorFromTemplate = function(requestor){
  $('.make_transit,.animated').removeClass('make_transit').removeClass('animated');
  Pegasus.IOManager.generateOutput(false, function(result){
    var z = $(/<body.*?>([\s\S]*)<\/body>/.exec(result.editor_cookie)[1]);
    z.find('[data-background-image]').css('backgroundSize', '100% 100%');
    z.find('[placeholder]').attr('placeholder', '');
    z.find('*').css('border-radius', '0');
    z.find('.vr-canvas-instance').removeClass('vr-canvas-instance');
    z.find('.editing').removeClass('editing');
    z.appendTo('body');

    z.css({
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: -1
    });

    var overlay = $('<div class="editing-overlay"/>');
    overlay.css('opacity', '1');
    overlay.css('overflow', 'hidden');
    overlay.css('overflow-y', 'auto');
    overlay.css('zIndex', '100000');
    overlay.appendTo('body');
    overlay.on('click', function(){
      $(this).remove();
      $('.color-selecting-canvas').remove();
      $('.color-displayer').remove();
    });

    var canvasOffsetParent = $('<div style="position:relative;">');

    overlay.append(canvasOffsetParent);

    import( /* webpackChunkName: "html2canvas" */ 'html2canvas').then(function(){
      html2canvas(z[0], {
        onrendered: function(canvas) {
          z.remove();
          canvasOffsetParent.append(canvas);
          $(canvas).addClass('color-selecting-canvas');

          $(canvas).css({
            position: 'absolute',
            top: 0,
            left: '50%',
            marginLeft: -1 * (canvas.width / 2),
            zIndex: 1000000 - 1
          });

          selectColorFromCanvas( canvas, requestor );
        }
      });
    });
  });

};

window.selectColorFromCanvas = function(canvas, requestor) {
  function findPositionInCanvas(obj) {
    var curleft = 0, curtop = 0;
    if (obj.offsetParent) {
      do {
        curleft += obj.offsetLeft;
        curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);
      return { x: curleft, y: curtop };
    }
    return undefined;
  }

  var rgbConvert = Pegasus.Helpers.convertRgbToHex;

  var displayer = $('<div class="color-displayer">');
  displayer.appendTo('body');
  displayer.css({
    display: 'none',
    width: 90,
    height: 90,
    position: 'absolute',
    left: 200,
    top: 200,
    zIndex: 1000000,
    borderRadius: 80,
    border: 'solid 1px rgb(163,163,163)',
    overflow: 'hidden'
  });

  var displayerBody = $('<div class="color-displayer-body">');
  displayerBody.css({
    position: 'relative',
    width: 100,
    height: 100,
  });

  displayer.append(displayerBody);

  displayer.mousemove(function(){
    $(this).css('display', 'none');
  });

  var lastCoordinate = "";

  $(canvas).css('cursor', 'crosshair');
  $(canvas).on('click', function(){
    var c = this.getContext('2d');
    var coordinates = lastCoordinate.split(',');

    var p = c.getImageData(coordinates[0], coordinates[1], 1, 1).data;
    var hex = "#" + ("000000" + rgbConvert(p[0], p[1], p[2])).slice(-6);
    requestor.onPickerChange(hex);
    $('.color-displayer').css('display', 'none');
  });
  $(canvas).on('mouseleave', function(e) {
    displayer.css('display', 'none');
  });
  $(canvas).on('mousemove mouseenter', function(e) {
    displayer.css('display', 'block');

    var pos = findPositionInCanvas(this);
    var x = e.pageX - pos.x;
    var y = e.pageY - (pos.y + $(this).offset().top);
    var coord = "x=" + x + ", y=" + y;
    var c = this.getContext('2d');
    var colors = [];

    var p, hex;

    for ( var j = y + 5; j > y - 5; j-- ) {
      for ( var i = x + 5; i > x - 5; i-- ) {
        p = c.getImageData(i, j, 1, 1).data;
        hex = "#" + ("000000" + rgbConvert(p[0], p[1], p[2])).slice(-6);
        colors.push(hex);
      }
    }

    p = c.getImageData(x, y, 1, 1).data;
    hex = "#" + ("000000" + rgbConvert(p[0], p[1], p[2])).slice(-6);

    displayerBody.html('');

    var colorElement;
    colors.reverse().forEach(function(color) {
      colorElement = $('<div class="color">');
      colorElement.css({
        boxShadow: 'inset 1px 1px 0px 0px rgb(163,163,163)',
        float: 'left',
        width: 10,
        height: 10,
        display: 'inline-block',
        background: color
      });
      displayerBody.append(colorElement);
    });

    var selection = $('<div class="selection"/>');
    selection.css({
      width: 9,
      height: 9,
      marginLeft: -10,
      marginTop: -10,
      position: 'absolute',
      top: '50%',
      left: '50%',
      border: 'solid 1px red'
    });

    displayerBody.append(selection);

    displayer.css({
      left: x + $(this).offset().left + 10,
      top: y + $(this).offset().top +10
    });

    lastCoordinate = ""+x+","+y;
  });
};

window.convertToDataURLviaCanvas = function(url, success, error, outputFormat, maxWidth, useCredentials, size){
  var maxHeight = maxWidth;
  var useCredentials = useCredentials || false;
  outputFormat = outputFormat || 'image/png';

  var img = new Image();
  img.onerror = error;
  img.crossOrigin = useCredentials ? 'use-credentials' : 'Anonymous';
  var isAlreadyConvertedTest = new RegExp("^data:" + outputFormat, "i");
  var isAlreadyConverted = isAlreadyConvertedTest.test(url);
  var maxImageSize = 4000000;
  if ( /^data/.test(url) ) {
    img.crossOrigin = null;
  }

  img.onload = function(){
    var canvas, ctx, dataURL;

    // just return the provided url if it fits and is base64
    if ( isAlreadyConverted && (this.width <= maxWidth) && (this.height <= maxHeight) ) {
      if(size >= maxImageSize){
        return error('images.error.too_big');
      }
      success({
        encoded: url
      });
      return;
    }

    var processImage = function(isAnimated){
      if ( isAnimated ) {
        if(size >= maxImageSize){
          return error('images.error.too_big');
        } else {
          return success({
            encoded: url
          });
        }
      }

      canvas = document.createElement('CANVAS');
      ctx = canvas.getContext('2d');

      if( this.width > maxWidth ) {
        canvas.width = maxWidth;
        canvas.height = (this.height / this.width) * maxWidth;
      } else if( this.height > maxHeight) {
        canvas.height = maxHeight;
        canvas.width = (this.width / this.height) * maxHeight;
      } else {
        canvas.width = this.width;
        canvas.height = this.height;
      }
      ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
      try {
        dataURL = canvas.toDataURL(outputFormat);
      } catch(e) {
        if ( error ) {
          error('images.error.try_again');
        }

        return;
      }
      success({
        encoded: dataURL
      });
      canvas = null;
    };

    var gifTest = new RegExp(".gif|image/gif", 'i');

    if ( gifTest.test(url) ) {
      isAnimatedGif(url, processImage.bind(this));
    } else {
      processImage.call(this, false);
    }
  };
  img.src = url;
};

window.encodeImageFileAsURL = function(cb) {
  return function(){
    var file = this.files[0],
      type, message;

    if ( !Pegasus.lookupController('upload').validate(file.name) ) {
      type = "extension";
      message = Em.I18n.t("errors." + type);

      Pegasus.lookupController('upload').setProperties({
        errors: [{
          key: type,
          message: message
        }]
      });
      return;
    }

    var reader  = new FileReader();
    var buffer = $('<img/>');

    reader.onloadend = function () {
      buffer.imagesLoaded().
        done(function(){
          cb(reader.result, file.name, file.size, file.type);
        }).attr('src', reader.result);
    }
    reader.readAsDataURL(file);
  }
};


String.prototype.strip = function(chr, untilMiss) {
  var str = this;

  if ( typeof( untilMiss ) === 'undefined' ) { untilMiss = true; }

  function frontMatch(){
    return str.substr(0,1) === chr;
  }

  function endMatch(){
    return str.substr(str.length-1,1) === chr;
  }

  if (frontMatch()) {
      str = str.substring(1);
  }

  if (endMatch()) {
      str = str.substring(0,str.length-1);
  }

  if ( untilMiss ) {
    while ( frontMatch() || endMatch() ) {
      str = String.prototype.strip.apply( str, [chr, false]);
    }
  }

  return str;
};

String.prototype.escapeHTML = function() {
  var str = this;
    return str.
      replace(/&/g, "&amp;").
      replace(/</g, "&lt;").
      replace(/>/g, "&gt;").
      replace(/"/g, "&quot;").
      replace(/'/g, "&#039;");
};

Pegasus.Helpers = (function(){
  function toCSS(cssObject){
    var result = '';

    for( var prop in cssObject ){
      if( cssObject.hasOwnProperty( prop ) ){
        if( /^-/.test(prop) ) { continue; }

        if( cssObject[ prop ] || cssObject[ prop ] === '' || cssObject[ prop ] === 0 ){
          result = [ result, prop.dasherize() + ':' + cssObject[ prop ] ].join(';');
        }
      }
    }
    return result.replace( /^\;+/, '').concat(';').replace( /^\;+/, '' );
  }

  return {
    detectLeftButtonDepressed: function(evt){
      evt = evt || window.event;
      if ("buttons" in evt) {
        return evt.buttons == 1;
      }
      var button = evt.which || evt.button;
      return button == 1;
    },
    scrapeAttributes: function(element, view, excludeClass) {
      var attributes,
        name;

      if( !element ) { return; }
      attributes = element.attributes;
      if( !attributes ) { return; }

      var attrNames = view.get('attributeBindings').toArray();

      var viewAttributes = attrNames.map(function(name){
        return name.split(':')[0];
      });

      for(var i=0; i < attributes.length; i++) {
        name = attributes[i].nodeName;
        if ( name === 'draggable' ) {
          continue;
        }
        if ( name === 'class' && excludeClass ) {
          continue;
        }
        if( view.get('type') && ( name === 'id' ) ) {
          continue;
        }
        if( viewAttributes.indexOf(name) < 0 ){
          attrNames.push(name);
        }
        view.set(name, attributes[i].nodeValue);
      }

      view.set('attributeBindings', attrNames);
    },

    scrapeClassNames: function(element, view) {
      var classes;

      if( !element) { return; }
      classes = $(element).prop('class').split(" ").concat( view.get('classNames') ).uniq();
      classes.removeObject("");

      if( !classes.length ) { return; }

      view.get('classNameBindings').forEach( function(cl){
        var parts = cl.split(":");

        parts.forEach( function(part){
          delete classes[part.camelize()];
          delete classes[part.dasherize()];
          delete classes[part];
        });
      });

      view.set('classNames', classes);
    },

    collectAttributes: function(context, attributeBindings) {
      //have to split the attribute to deal with ternary ember attribute bindings.
      var attributeSplit,
        attributesConcated,
        attributeValue;

      return attributeBindings ?
        attributeBindings.map(function(item) {
          var attributeSplit = item.split(':');
          if (attributeSplit.length > 1) {
            attributeValue = this.get(attributeSplit[0]);
            attributesConcated = attributeValue ? attributeSplit[attributeSplit.length-1] + '="' + attributeValue + '"' : '';
          }
          else {
            attributesConcated = item + '="' + this.get(item) + '"';

          }
          return attributesConcated;
        }.bind(context)).join(' ') : '';
    },

    collectDataAttributes: function( el ){
      var element = el;
      var elements = [].slice.call(element.querySelectorAll('*') || []);
      var data = elements.reduce( function(accum, item){
        accum = $.extend( accum, item.dataset );
        return accum;
      }, {});

      // we, so badly, want the element `dataset` version because jquery
      // caches the values internally and that doesn't jive well with dynamically
      // bound values
      data = $.extend( data, element.dataset );
      var test = /bindattr/;

      Object.keys( data ).forEach( function(key){
        if ( !test.test(key)) {
          data['data'+key.capitalize()] = data[key];
        }
        delete data[key];
      });

      return data;
    },

    strftime: function (date, format) {
      if (!date) { return ''; }
      if ( date === date.toString() ) { date = new Date(date); }
      format = format || '%b %e, %Y at %l:%M%P %Z';

      return date.strftime(format);
    },
    addOneTimeObserver: function (object, property, value, observer) {
      var observerWrapper = function () {
        if (this.get(property) === value) {
          observer.call(this, arguments);
          this.removeObserver(property, observerWrapper);
        } else if ( ! value ) {
          observer.call(this, arguments);
          this.removeObserver(property, observerWrapper);
        }
      };

      if ( object.get(property) === value ) {
        observer.call(this, arguments);
        return;
      }

      object.addObserver(property, observerWrapper);
    },

    isMustacheContent: function(string){
      return ( /\{\{/.test( string ) ) && (  /\}\}/.test(string) );
    },

    isRightClickPressed: function(e){
      var rightClick = 2;
      return ( e.button === rightClick || e.ctrlKey );
    },

    convertString: {
      fromEncodedHTML: {
        toUnencodedHTML: function(html){
          function sanitize(htmlString){
            return htmlString.replace(
                /\&lt\;/g, '<'
              ).replace(
                /\&gt\;/g, '>'
              ).replace(
                /\&quot\;/g, '"'
              ).replace(
                /\&amp\;/g, '&'
              );
          }
          Ember.assert( "expected string argument", typeof( html ) === 'string' );
          return sanitize(html);
        }
      },
      fromRGB: {
        toHEX: function(color) {
          var isHex = color.search(/^\#/) === 0,
            test = /^rgb[a]?\([\s+]?(\d+),[\s+]?(\d+),[\s+]?(\d+)/,
            bg;

          if( isHex ) { return color; }

          Ember.assert( "You didn't pass an rgb value to be converted", color.search("rgb") === 0 );

          function hex(x) {
            return ("0" + parseInt(x, 10).toString(16)).slice(-2);
          }

          bg = color.match(test);

          return "#" + (hex(bg[1]) + hex(bg[2]) + hex(bg[3])).toUpperCase();
        }
      },
      fromURL: {
        toFileName: function(src){
          var hasParams = /\?/.test(src);

          return src.substr(
            src.lastIndexOf('/')+1,
            hasParams ?
              ( src.lastIndexOf( '?' ) - 1 ) - src.lastIndexOf('/') : src.length
          );
        }
      },
      fromCSS: {
        toObject: function( styleString ){
          var style;
          if( !styleString) { return {}; }

          style = styleString.split(';');

          return style.reduce(function(result, current){
            var parts = current.split(':'),
              rValueParts;

            if(parts.length > 2){

              rValueParts = parts.slice( 1, parts.length ).join(':');
              parts = [parts[0], rValueParts];

            } else if( !parts[0] || !parts[1] ) {
              return result;
            } // ember mapped binding isActive:active

            result[ parts[0].trim().camelize() ] = parts[1].trim();
            return result;
          }, {});
        }
      }
    },

    convertHexToRgb: function(hex) {
      if ( !hex ) { return ''; }
      hex = hex.strip('#');
      var bigint = parseInt(hex, 16);
      var r = (bigint >> 16) & 255;
      var g = (bigint >> 8) & 255;
      var b = bigint & 255;

      return [r,g,b];
    },

    convertRgbToHex: function (r, g, b) {
      return "#" + ((1 << 24) + (parseInt(r, 10) << 16) + (parseInt(g, 10) << 8) + parseInt(b, 10)).toString(16).slice(1);
    },
    convertCSS: {
      toObject: function(css){
        var parts = css.split(';'),
          styleParts,
          key, value;

        return parts.reduce(function(accum,item){
          styleParts = item.split(':');
          key = styleParts[0];
          value = styleParts.slice(1).join(':');

          if ( key && value ) {
            accum[ key ] = value;
          }
          return accum;
        }, {});
      }
    },
    convertObject: {
      toCSS: toCSS
    },
    convertObjects: {
      toCSS: function(objects){
        return Pegasus.Helpers.convertObject.toCSS(
          objects.reduce( function(accum, item){
            accum = $.extend( accum, item );
            return accum;
          }, {})
        );
      }
    }
  };
})();

if ( document.createElement('svg').outerHTML === '<svg></svg>' ) {
  window.svgConverter = window.convertSVGToBase64;
} else {
  window.svgConverter = window.convertSVGToBase64ForIE;
  window.svgConverter.isIE = true;
}

Object.defineProperty( Array.prototype, 'sum', {
  value: function( array ){
    var merge = array || [];

    return merge.concat.apply( merge, this ).reduce( function(sum, item){
      return sum + item;
    }, 0);
  },
  enumerable: false,
  configurable: false,
  writable: false
});

Object.defineProperty( Array.prototype, 'flatten', {
  value: function( array ){
    var merge = array || [];

    return merge.concat.apply( merge, this ).reduce( function(accum, item){
      if ( Array.isArray(item) ) {
        accum = Array.prototype.concat.apply( accum, item.flatten() );
      } else {
        accum.push(item);
      }

      return accum;
    }, []);
  },
  enumerable: false,
  configurable: false,
  writable: false
});

Object.defineProperty( String.prototype, 'toDOM', {
  value: function(){
    var parser = new DOMParser(),
        content = 'text/html',
        DOM = parser.parseFromString(this, content);

    // return element
    return DOM.body.childNodes[0];
  },
  enumerable: true,
  configurable: false,
  writable: false
});
